module.exports = __webpack_public_path__ + "img/emailed.27b88076.gif";